
export function IntegrationsSection() {
  const integrations = [
    { name: 'Microsoft 365', icon: 'ri-microsoft-fill', description: 'Outlook, Teams, OneDrive' },
    { name: 'Google Workspace', icon: 'ri-google-fill', description: 'Gmail, Drive, Meet' },
    { name: 'WhatsApp Business', icon: 'ri-whatsapp-fill', description: 'Business messaging' },
    { name: 'Slack', icon: 'ri-slack-fill', description: 'Team communication' },
    { name: 'Zoom', icon: 'ri-vidicon-fill', description: 'Video conferencing' },
    { name: 'Dropbox', icon: 'ri-dropbox-fill', description: 'File sharing' }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Seamless Integration with Your Business Tools
            </h2>
            <p className="text-xl text-gray-400">
              Driscop works with the platforms your team already uses every day
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {integrations.map((integration, index) => (
              <div key={index} className="bg-gray-800/50 p-6 rounded-xl text-center hover:bg-gray-800/70 transition-all border border-gray-700">
                <div className="w-16 h-16 bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${integration.icon} text-2xl text-blue-400`}></i>
                </div>
                <h3 className="font-semibold text-white mb-2">
                  {integration.name}
                </h3>
                <p className="text-gray-400 text-sm">
                  {integration.description}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-semibold text-white mb-4">
                  No IT Department? No Problem.
                </h3>
                <p className="text-gray-400 mb-6 leading-relaxed">
                  Our remote deployment system means you can protect your entire organization in under 5 minutes, without any technical expertise or infrastructure changes.
                </p>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3"></i>
                    <span className="text-gray-700">Automatic installation across all devices</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3"></i>
                    <span className="text-gray-700">Zero configuration required</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3"></i>
                    <span className="text-gray-700">Continuous updates and monitoring</span>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-400 mb-2">&lt;5 min</div>
                <div className="text-gray-400 mb-4">Complete deployment time</div>
                <button className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                  Start Setup Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
